import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { maxLength, required, yesNoFlag, nullable, validateValueIsUnique } from '../../shared/forms/validators';

const getBusinessDescription = ({ formik, formContext }) => {
  const businessCode = formik.values.businessCode;
  const foundBusinessCode = formContext.businessCodeOptions.find(({ value }) => value === businessCode);

  return foundBusinessCode && foundBusinessCode.businessDescription;
};

const validateBusinessUnit = validateValueIsUnique({
  optionsKey: 'businessUnitOptions',
  message: 'Business Unit already exists.',
  conditionFn: (option, selectedValue, context) =>
    option.value === selectedValue && option.businessUnit !== context.parent.businessUnit,
});

const schema = [
  {
    name: 'businessUnit',
    component: InputFormik,
    meta: { label: 'Business Unit', optionsKey: 'businessUnitOptions' },
    options: {
      yupType: yupString(),
      validationRules: [maxLength(6), required, validateBusinessUnit],
      disabledWhenEditing: true,
    },
    additionalProps: { required: true },
  },
  {
    name: 'businessUnitDescription',
    component: InputFormik,
    meta: { label: 'Business Unit Description' },
    options: {
      yupType: yupString(),
      validationRules: [maxLength(240), required],
    },
    additionalProps: { required: true },
  },
  {
    name: 'enabledFlag',
    component: SelectFormik,
    meta: { label: 'Enabled Flag', optionsKey: 'enabledFlagOptions' },
    options: {
      yupType: yupString(),
      validationRules: [yesNoFlag, required],
    },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'businessCode',
    component: SelectFormik,
    meta: { label: 'Business Code', optionsKey: 'businessCodeOptions' },
    options: {
      yupType: yupString(),
      validationRules: [nullable],
    },
    additionalProps: { clearable: true, virtualized: true },
  },
  {
    name: 'businessDescription',
    component: InputFormik,
    meta: { label: 'Business Description', valueGetter: getBusinessDescription },
    options: {},
    additionalProps: { disabled: true, handleExternalChange: true },
  },
  {
    name: 'ancestorList',
    component: InputFormik,
    meta: { label: 'Ancestor List' },
    options: {
      yupType: yupString(),
    },
  },
];

export default schema;
